export default "__VITE_ASSET__8a2a081d__"